<template>
	<div>
		<el-header style="background-color: #545c64; display: flex; align-items: center; padding: 0 40px;">
			<!-- 左侧图标 -->
			<img src="../../src/assets/app_logo.jpg" alt="Logo" style="height: 40px; margin-right: 20px;">
			<!-- 标题文字 -->
			<h1 style="color: #ffffff; font-family: 'Arial', sans-serif; font-size: 24px; margin: 0 auto;">QIUI 后台管理系统
			</h1>
		</el-header>

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<el-container v-if="!errorOccurred" style="height: calc(100vh - 60px); background-color:#545c64;">
			<!-- 下面 -->
			<el-aside width="144px">
				<!-- 下面的左边 -->
				<el-menu default-active="/WindControlHome" @select="handleSelect" class="el-menu-vertical-demo"
					background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">

					<el-menu-item v-if="hasPermission(1)" index="/WindControlHome">
						<i class="el-icon-s-custom"></i>
						<span slot="title">风控管理</span>
					</el-menu-item>

					<el-menu-item v-if="hasPermission(2)" index="/WarehouseHome">
						<i class="el-icon-document"></i>
						<span slot="title">入库管理</span>
					</el-menu-item>

					<el-menu-item v-if="hasPermission(3)" index="/AfterSalesHome">
						<i class="el-icon-setting"></i>
						<span slot="title">售后管理</span>
					</el-menu-item>

					<el-submenu v-if="hasPermission(4)" index="1">
						<template slot="title">
							<i class="el-icon-bank-card"></i>
							<span>直播管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/RealNameHome">实名认证</el-menu-item>
							<el-menu-item index="/BankCardHome">银行卡认证</el-menu-item>
							<el-menu-item index="/WithdrawalHome">提现申请</el-menu-item>
							<el-menu-item index="/VoiceRoomManagement">语音房管理</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<el-menu-item v-if="hasPermission(5)" index="/SingleSummary">
						<i class="el-icon-position"></i>
						<span slot="title">其他</span>
					</el-menu-item>

				</el-menu>
			</el-aside>

			<el-main style="background-color: #ffffff; overflow: auto;  padding: 0;   border: none;   outline: none;">
				<!-- 下面的右边 -->
				<div style="padding: 5px;">
					<router-view></router-view>
				</div>
			</el-main>

		</el-container>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		created() { // 在组件创建时触发，通常用于初始化数据
		},
		mounted() {
			this.fetchData(); //获取当前账号的权限
		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				isfirst: 0, //是否是第一次加载
				password: '',
				//页面路由权限 售后系统管理员用户所拥有的页面权限。0 所有，1 风控管理，2 入库管理，3售后管理，4 直播管理，5 其他；多个页面权限使用英文逗号隔开
				sysUserPermissionPage: '0',
				errorOccurred: false, // 用于标记是否发生错误
			};
		},
		methods: {
			handleSelect(key, keyPath) {
				if (this.$route.path !== key) { //同一个地址 不重复导航
					this.$router.push(key);
				}
			},
			fetchData() { //获取当前账号的权限
				this.loadingData = true;
				const requestData = {}; //传递的参数

				axios.post(this.$p_url + '/afterSale/H5/getSysUserPermissionRout/' + Cookies.get("uid"), requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("获取当前账号的权限 数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.sysUserPermissionPage = response.data.data.sysUserPermissionPage;
							console.log("当前的权限 ：", this.sysUserPermissionPage)
							this.setDefaultRoute(); //设置默认路由
						} else {
							this.errorOccurred = true;
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						this.errorOccurred = true;
						alert('请求失败:' + error);
					});
			},
			hasPermission(permission) {
				if (this.sysUserPermissionPage === '0') {
					return true;
				}
				const permissions = this.sysUserPermissionPage.split(',').map(Number);
				return permissions.includes(permission);
			},
			setDefaultRoute() { // 根据权限设置默认路由
				let defaultRoute = '/WindControlHome'; // 默认路由
				if (this.sysUserPermissionPage !== '0') {
					const permissions = this.sysUserPermissionPage.split(',').map(Number);
					if (permissions.includes(1)) {
						defaultRoute = '/WindControlHome';
					} else if (permissions.includes(2)) {
						defaultRoute = '/WarehouseHome';
					} else if (permissions.includes(3)) {
						defaultRoute = '/AfterSalesHome';
					} else if (permissions.includes(4)) {
						defaultRoute = '/RealNameHome';
					} else if (permissions.includes(5)) {
						defaultRoute = '/SingleSummary';
					}
				}
				if (this.$route.path !== defaultRoute) {
					this.$router.push({
						path: defaultRoute
					});
				}
			},
		}
	};
</script>

<style>
	h1 {
		margin: 0;
		color: #ddd;
	}
</style>